<template>
  <div v-if="!hasAccess && isLoaded">
    <div class="info-section">
    <v-icon color="red">mdi-alert-circle-outline</v-icon>
    <div class="info">
      {{ accessMessage }}
    </div>
  </div>
  </div>
  <div v-else>
    <div id="foldercontainer"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getBoxToken } from '@/service/engagement.js'
import { getWorkfileId } from '@/utils/globalUtil'

export default {
  name: 'BoxFolderPickerComponent',
  props: {
    assignmentData: {
      type: Object,
    }
  },
  data() {
    return {
      isLoaded: false,
      hasAccess: false,
      accessMessage: null,
      selectedFolder: null,
    }
  },
  watch: {
    isLoaded(newValue) {
      if (newValue) {
        this.$emit('loaded', {isLoaded: this.isLoaded, hasAccess: this.hasAccess})
      }
    }
  },
  methods: {
    ...mapActions({
      add: "notification/add",
    }),

    handleFolderSelection(folder) {
      this.selectedFolder = {
        id: folder.id,
        name: folder.name,
        path: folder.path_collection ? folder.path_collection.entries : [],
      }
      this.$emit('folderSelected', this.selectedFolder)
    },

    async openFolderPicker() {
      try {
        let workfile = this.assignmentData.workFileLink
        let folderId = getWorkfileId(workfile)
        let boxTokenObject = await getBoxToken(folderId)
        this.isLoaded = true
        if (boxTokenObject == null || !boxTokenObject.hasUserAccount) {
          let notification = {
            type: 'error',
            message: 'You do not have access to Box.',
          }
          // this.add(notification)
          this.hasAccess = false
          this.accessMessage = notification.message
        } else if (!boxTokenObject.hasFolderAccess) {
          let notification = {
            type: 'error',
            message: 'You do not have access to this Box folder.',
          }
          // this.add(notification)
          this.hasAccess = false
          this.accessMessage = notification.message
        } else {
          this.hasAccess = true
          this.accessMessage = null
          const that = this
          let boxToken = boxTokenObject.token
          let boxFolderId = boxTokenObject.folderId

          // Use Box Folder Picker instead of File Picker
          let folderPicker = new Box.FolderPicker()

          this.$nextTick(() => {
            folderPicker.show(boxFolderId, boxToken, {
              container: '#foldercontainer',
              logoUrl: 'box',
              canUpload: false, // Disable upload for folder picker
              canSetShareAccess: false,
              canCreateNewFolder: false, // Optional: disable folder creation
              chooseButtonLabel: 'Select Folder',
              maxSelectable: 1, // Allow only 1 folder selection
            })
          })

          // Listen to selection change (when radio button is clicked)
          folderPicker.addListener('itemSelectionChange', function (folders) {
            if (folders && folders.length > 0) {
              console.log('select')
              that.handleFolderSelection(folders[0])
            }
          })

          // Alternative: Listen to 'selectionChange' event
          folderPicker.addListener('selection', function (selection) {
            if (selection && selection.length > 0) {
              console.log('selection')
              that.handleFolderSelection(selection[0])
            }
          })
          folderPicker.addListener('choose', function (folders) {
            // folders array will contain only 1 folder due to maxSelectable: 1
            if (folders && folders.length > 0) {
              that.handleFolderSelection(folders[0])
            }
          })

          folderPicker.addListener('cancel', function () {
            folderPicker.clearCache()
            that.$emit('closeModal')
          })
        }
      } catch (error) {
        console.error('Error opening folder picker:', error)
        let notification = {
          type: 'error',
          message: 'Failed to load Box folder',
        }
        // this.add(notification)
        this.isLoaded = true
        this.accessMessage =  notification.message
        this.hasAccess = false
      }
    },
  },
  mounted() {
    this.openFolderPicker()
  },
}
</script>

<style scoped>
.info-section {
  display: flex;
    align-items: center;
    background-color: #ffe7e7;
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 4px;
    border: 1px solid #b92424a6;
}

.info-section .info {
  margin-left: 8px;
  font-size: 14px;
}
.disableStyle {
  pointer-events: none;
  opacity: 0.6;
}
</style>
